export const ERROR_HEADER_LABEL = 'There was a problem...';
export const ERROR_BUTTON_LABEL = 'Retry';
